import { useCallback, useContext, useMemo } from "react";

import { fetchLegalDocuments, TLegalDocumentType } from "@/data/legal-documents";
import { refresh } from "@/data/session";
import { putLegalDocuments } from "@/data/users";
import { SessionContext } from "@/infrastructure/Session";

const requiredLegalDocumentsTypes: TLegalDocumentType[] = ["USER_ACCESS_AGREEMENT", "PRIVACY_POLICY"];

export function useLegalDocumentsGuard() {
  const { payload, update } = useContext(SessionContext);
  const updatedLegalDocuments: TLegalDocumentType[] = useMemo(
    () => payload?.updatedLegalDocuments ?? [],
    [payload?.updatedLegalDocuments],
  );
  const requiredLegalDocuments: TLegalDocumentType[] = useMemo(
    () => updatedLegalDocuments.filter(document => requiredLegalDocumentsTypes.includes(document)),
    [updatedLegalDocuments],
  );

  const acceptLegalDocuments = useCallback(async (legalDocumentsTypes: TLegalDocumentType[]) => {
    const legalDocuments = await fetchLegalDocuments();

    await putLegalDocuments(
      undefined,
      legalDocuments
        .filter(legalDocument => legalDocumentsTypes.includes(legalDocument.type))
        .map(({ type, version }) => ({ type, version })),
    );

    const user = await refresh();
    update(user);
  }, []);

  return {
    hasRequiredLegalDocumentsToAccept: !!requiredLegalDocuments.length,
    updatedLegalDocuments,
    requiredLegalDocuments,
    acceptLegalDocuments,
  };
}
